export default "__VITE_ASSET__Cae36u2j__"